// extracted by mini-css-extract-plugin
module.exports = {"centered":"PasswordRecovery_centered__1f03G","centeredText":"PasswordRecovery_centeredText__3AkmQ"};